// Remover import * as XLSX from 'xlsx'; se não utilizado

const OBJETIVOS_PERMITIDOS = ['Awareness', 'Brandformance'];

interface PlanData {
  Objetivo: string;
  Plataforma: string;
  Formatos: string;
  Estrategias: string;
  Compra: string;
  'CPM Estados e Brasil': number;
  'CPM Grandes Metropoles': number;
  'CPM Cidade Pequena': number;
  'Com BV até 10% - Estados e Brasil': number;
  'Com BV até 10% - Grandes Metrópoles': number;
  'Com BV até 10% - Cidades Pequenas': number;
}

type Regiao = 'Estados e Brasil' | 'Grandes Metropoles' | 'Cidades pequenas';

export type { Regiao };

interface TabelaCPM {
  [key: string]: {
    [K in Regiao]: number;
  };
}

// Dados fixos para demonstração
export const DEMO_DATA: PlanData[] = [
  // Awareness - DV360
  {
    Objetivo: 'Awareness',
    Plataforma: 'DV360',
    Formatos: 'Display IAB',
    Estrategias: 'Platform Data,Wishlist Open, Custom affinity, Contextual (Categories), Demographics, Lookalike',
    Compra: 'CPM',
    'CPM Estados e Brasil': 4.49,
    'CPM Grandes Metropoles': 9.00,
    'CPM Cidade Pequena': 14.00,
    'Com BV até 10% - Estados e Brasil': 6.28,
    'Com BV até 10% - Grandes Metrópoles': 12.60,
    'Com BV até 10% - Cidades Pequenas': 19.60
  },
  {
    Objetivo: 'Awareness',
    Plataforma: 'DV360',
    Formatos: 'Native',
    Estrategias: 'Platform Data,Wishlist Open, Custom affinity, Contextual (Categories), Demographics, Lookalike',
    Compra: 'CPM',
    'CPM Estados e Brasil': 8.00,
    'CPM Grandes Metropoles': 8.29,
    'CPM Cidade Pequena': 11.43,
    'Com BV até 10% - Estados e Brasil': 11.20,
    'Com BV até 10% - Grandes Metrópoles': 11.60,
    'Com BV até 10% - Cidades Pequenas': 16.00
  },
  {
    Objetivo: 'Awareness',
    Plataforma: 'DV360',
    Formatos: 'Youtube',
    Estrategias: 'Non Skippable',
    Compra: 'CPV',
    'CPM Estados e Brasil': 0.09,
    'CPM Grandes Metropoles': 0.14,
    'CPM Cidade Pequena': 0.20,
    'Com BV até 10% - Estados e Brasil': 0.12,
    'Com BV até 10% - Grandes Metrópoles': 0.20,
    'Com BV até 10% - Cidades Pequenas': 0.28
  },
  {
    Objetivo: 'Awareness',
    Plataforma: 'DV360',
    Formatos: 'Youtube',
    Estrategias: 'In Stream Skippable e Bumper',
    Compra: 'CPV',
    'CPM Estados e Brasil': 0.09,
    'CPM Grandes Metropoles': 0.14,
    'CPM Cidade Pequena': 0.20,
    'Com BV até 10% - Estados e Brasil': 0.12,
    'Com BV até 10% - Grandes Metrópoles': 0.20,
    'Com BV até 10% - Cidades Pequenas': 0.28
  },
  {
    Objetivo: 'Awareness',
    Plataforma: 'DV360',
    Formatos: 'Youtube',
    Estrategias: 'Non Skippable',
    Compra: 'CPM',
    'CPM Estados e Brasil': 40.00,
    'CPM Grandes Metropoles': 45.71,
    'CPM Cidade Pequena': 57.14,
    'Com BV até 10% - Estados e Brasil': 56.00,
    'Com BV até 10% - Grandes Metrópoles': 64.00,
    'Com BV até 10% - Cidades Pequenas': 80.00
  },
  {
    Objetivo: 'Awareness',
    Plataforma: 'DV360',
    Formatos: 'Youtube',
    Estrategias: 'In Stream Skippable e Bumper',
    Compra: 'CPM',
    'CPM Estados e Brasil': 40.00,
    'CPM Grandes Metropoles': 45.71,
    'CPM Cidade Pequena': 57.14,
    'Com BV até 10% - Estados e Brasil': 56.00,
    'Com BV até 10% - Grandes Metrópoles': 64.00,
    'Com BV até 10% - Cidades Pequenas': 80.00
  },
  {
    Objetivo: 'Awareness',
    Plataforma: 'DV360',
    Formatos: 'Youtube',
    Estrategias: 'Shorts',
    Compra: 'CPM',
    'CPM Estados e Brasil': 15.00,
    'CPM Grandes Metropoles': 18.00,
    'CPM Cidade Pequena': 21.00,
    'Com BV até 10% - Estados e Brasil': 22.50,
    'Com BV até 10% - Grandes Metrópoles': 27.00,
    'Com BV até 10% - Cidades Pequenas': 31.50
  },
  {
    Objetivo: 'Awareness',
    Plataforma: 'DV360',
    Formatos: 'Vídeo Open',
    Estrategias: 'Platform Data,Wishlist Open, Custom affinity, Contextual (Categories), Demographics, Lookalike',
    Compra: 'CPV',
    'CPM Estados e Brasil': 0.09,
    'CPM Grandes Metropoles': 0.14,
    'CPM Cidade Pequena': 0.20,
    'Com BV até 10% - Estados e Brasil': 0.12,
    'Com BV até 10% - Grandes Metrópoles': 0.20,
    'Com BV até 10% - Cidades Pequenas': 0.28
  },
  {
    Objetivo: 'Awareness',
    Plataforma: 'DV360',
    Formatos: 'Vídeo Open',
    Estrategias: 'Platform Data,Wishlist Open, Custom affinity, Contextual (Categories), Demographics, Lookalike',
    Compra: 'CPM',
    'CPM Estados e Brasil': 15.00,
    'CPM Grandes Metropoles': 23.57,
    'CPM Cidade Pequena': 32.14,
    'Com BV até 10% - Estados e Brasil': 21.00,
    'Com BV até 10% - Grandes Metrópoles': 33.00,
    'Com BV até 10% - Cidades Pequenas': 45.00
  },
  // Brandformance - DV360
  {
    Objetivo: 'Brandformance',
    Plataforma: 'DV360',
    Formatos: 'Display IAB',
    Estrategias: 'Platform Data+Wishlist, Keywords+Wishlist, Wishlist+Audience, Custom affinity+Wishlist, Contextual (Categories)+Audience, 3rdParty Data, Open App (In App), Demographics+Wishlist, Remarketing, Lookalike+Wishlist',
    Compra: 'CPM',
    'CPM Estados e Brasil': 8.00,
    'CPM Grandes Metropoles': 12.00,
    'CPM Cidade Pequena': 18.00,
    'Com BV até 10% - Estados e Brasil': 11.20,
    'Com BV até 10% - Grandes Metrópoles': 16.80,
    'Com BV até 10% - Cidades Pequenas': 25.20
  },
  {
    Objetivo: 'Brandformance',
    Plataforma: 'DV360',
    Formatos: 'Native',
    Estrategias: 'Platform Data+Wishlist, Keywords+Wishlist, Wishlist+Audience, Custom affinity+Wishlist, Contextual (Categories)+Audience, 3rdParty Data, Open App (In App), Demographics+Wishlist, Remarketing, Lookalike+Wishlist',
    Compra: 'CPM',
    'CPM Estados e Brasil': 17.14,
    'CPM Grandes Metropoles': 19.00,
    'CPM Cidade Pequena': 22.86,
    'Com BV até 10% - Estados e Brasil': 24.00,
    'Com BV até 10% - Grandes Metrópoles': 26.60,
    'Com BV até 10% - Cidades Pequenas': 32.00
  },
  {
    Objetivo: 'Brandformance',
    Plataforma: 'DV360',
    Formatos: 'YouTube',
    Estrategias: 'Non-Skippable e Bumper',
    Compra: 'CPV',
    'CPM Estados e Brasil': 0.09,
    'CPM Grandes Metropoles': 0.14,
    'CPM Cidade Pequena': 0.20,
    'Com BV até 10% - Estados e Brasil': 0.12,
    'Com BV até 10% - Grandes Metrópoles': 0.20,
    'Com BV até 10% - Cidades Pequenas': 0.28
  },
  {
    Objetivo: 'Brandformance',
    Plataforma: 'DV360',
    Formatos: 'YouTube',
    Estrategias: 'Skippable - Vídeo com mais',
    Compra: 'CPV',
    'CPM Estados e Brasil': 0.17,
    'CPM Grandes Metropoles': 0.23,
    'CPM Cidade Pequena': 0.29,
    'Com BV até 10% - Estados e Brasil': 0.24,
    'Com BV até 10% - Grandes Metrópoles': 0.32,
    'Com BV até 10% - Cidades Pequenas': 0.40
  },
  {
    Objetivo: 'Brandformance',
    Plataforma: 'DV360',
    Formatos: 'YouTube',
    Estrategias: 'Non-Skippable, In Stream, Discovery e Bumper',
    Compra: 'CPM',
    'CPM Estados e Brasil': 40.00,
    'CPM Grandes Metropoles': 45.71,
    'CPM Cidade Pequena': 57.14,
    'Com BV até 10% - Estados e Brasil': 56.00,
    'Com BV até 10% - Grandes Metrópoles': 64.00,
    'Com BV até 10% - Cidades Pequenas': 80.00
  },
  {
    Objetivo: 'Brandformance',
    Plataforma: 'DV360',
    Formatos: 'Vídeo Open',
    Estrategias: 'Platform Data, Keywords, Wishlist+Audience, Custom affinity, Contextual (Categories), 3rdParty Data, Open App (In App), Demographics, Remarketing, Lookalike+Wishlist',
    Compra: 'CPM',
    'CPM Estados e Brasil': 20.00,
    'CPM Grandes Metropoles': 28.57,
    'CPM Cidade Pequena': 37.14,
    'Com BV até 10% - Estados e Brasil': 28.00,
    'Com BV até 10% - Grandes Metrópoles': 40.00,
    'Com BV até 10% - Cidades Pequenas': 52.00
  },
  {
    Objetivo: 'Brandformance',
    Plataforma: 'DV360',
    Formatos: 'Vídeo Open',
    Estrategias: 'Platform Data, Keywords, Wishlist+Audience, Custom affinity, Contextual (Categories), 3rdParty Data, Open App (In App), Demographics, Remarketing, Lookalike+Wishlist',
    Compra: 'CPV',
    'CPM Estados e Brasil': 0.09,
    'CPM Grandes Metropoles': 0.14,
    'CPM Cidade Pequena': 0.20,
    'Com BV até 10% - Estados e Brasil': 0.12,
    'Com BV até 10% - Grandes Metrópoles': 0.20,
    'Com BV até 10% - Cidades Pequenas': 0.28
  },
  {
    Objetivo: 'Brandformance',
    Plataforma: 'DV360',
    Formatos: 'Vídeo Open',
    Estrategias: 'Platform Data, Keywords, Wishlist+Audience, Custom affinity, Contextual (Categories), 3rdParty Data, Open App (In App), Demographics, Remarketing, Lookalike+Wishlist',
    Compra: 'CPV',
    'CPM Estados e Brasil': 0.17,
    'CPM Grandes Metropoles': 0.23,
    'CPM Cidade Pequena': 0.29,
    'Com BV até 10% - Estados e Brasil': 0.24,
    'Com BV até 10% - Grandes Metrópoles': 0.32,
    'Com BV até 10% - Cidades Pequenas': 0.40
  },
  // Awareness - GAMA
  {
    Objetivo: 'Awareness',
    Plataforma: 'GAMA',
    Formatos: 'Display IAB',
    Estrategias: 'Remarketing, Open, Wishlist, Lookalike, Demographics, 3rdParty',
    Compra: 'CPM',
    'CPM Estados e Brasil': 12.00,
    'CPM Grandes Metropoles': 14.00,
    'CPM Cidade Pequena': 17.00,
    'Com BV até 10% - Estados e Brasil': 12.80,
    'Com BV até 10% - Grandes Metrópoles': 20.00,
    'Com BV até 10% - Cidades Pequenas': 16.00
  },
  {
    Objetivo: 'Awareness',
    Plataforma: 'GAMA',
    Formatos: 'Vídeo Open',
    Estrategias: 'Remarketing, Open, Wishlist, Lookalike, Demographics, 3rdParty',
    Compra: 'CPV',
    'CPM Estados e Brasil': 0.14,
    'CPM Grandes Metropoles': 0.20,
    'CPM Cidade Pequena': 0.23,
    'Com BV até 10% - Estados e Brasil': 0.20,
    'Com BV até 10% - Grandes Metrópoles': 0.32,
    'Com BV até 10% - Cidades Pequenas': 0.28
  },
  // Brandformance - GAMA
  {
    Objetivo: 'Brandformance',
    Plataforma: 'GAMA',
    Formatos: 'Display IAB',
    Estrategias: 'Remarketing, Open, Wishlist, Lookalike, Demographics, 3rdParty',
    Compra: 'CPM',
    'CPM Estados e Brasil': 15.00,
    'CPM Grandes Metropoles': 17.00,
    'CPM Cidade Pequena': 20.00,
    'Com BV até 10% - Estados e Brasil': 16.00,
    'Com BV até 10% - Grandes Metrópoles': 18.00,
    'Com BV até 10% - Cidades Pequenas': 24.00
  },
  {
    Objetivo: 'Brandformance',
    Plataforma: 'GAMA',
    Formatos: 'Vídeo Open',
    Estrategias: 'Remarketing, Open, Wishlist, Lookalike, Demographics, 3rdParty',
    Compra: 'CPV',
    'CPM Estados e Brasil': 0.17,
    'CPM Grandes Metropoles': 0.23,
    'CPM Cidade Pequena': 0.26,
    'Com BV até 10% - Estados e Brasil': 0.18,
    'Com BV até 10% - Grandes Metrópoles': 0.26,
    'Com BV até 10% - Cidades Pequenas': 0.32
  }
];

// Inicializar tabelaCPM com os dados
const tabelaCPM: TabelaCPM = {};

DEMO_DATA.forEach(row => {
  // Normalizar a estratégia
  const estrategiaNormalizada = row.Estrategias
    .split(',')
    .map(e => e.trim())
    .filter(e => e.length > 0)
    .join(',');

  const chave = `${row.Objetivo}|${row.Plataforma}|${row.Formatos}|${estrategiaNormalizada}|${row.Compra}`;
  
  tabelaCPM[chave] = {
    'Estados e Brasil': row['CPM Estados e Brasil'],
    'Grandes Metropoles': row['CPM Grandes Metropoles'],
    'Cidades pequenas': row['CPM Cidade Pequena']
  };
});

export const loadExcelData = async (): Promise<void> => {
  // Dados já estão carregados
  console.log('=== Tabela CPM carregada ===');
  console.log('Chaves disponíveis:', Object.keys(tabelaCPM));
};

export const getCPM = (
  objetivo: string,
  plataforma: string,
  formato: string,
  estrategia: string,
  compra: string,
  regiao: Regiao,
  bv: boolean = false
): number | null => {
  console.log('=== Parâmetros para getCPM ===');
  console.log('Objetivo:', objetivo);
  console.log('Plataforma:', plataforma);
  console.log('Formato:', formato);
  console.log('Estratégias:', estrategia);
  console.log('Tipo de Compra:', compra);
  console.log('Região:', regiao);
  console.log('BV:', bv);

  // Procurar nos dados de demonstração
  const chave_de_busca = `${objetivo}|${plataforma}|${formato}|${estrategia}|${compra}`;
  console.log('Chave de busca:', chave_de_busca);

  // Dividir as estratégias em um array
  const estrategiasSelecionadas = estrategia.split(',').map(e => e.trim());
  
  // Encontrar todas as correspondências que incluem pelo menos uma das estratégias selecionadas
  const matches = DEMO_DATA.filter(item =>
    item.Objetivo === objetivo &&
    item.Plataforma === plataforma &&
    item.Formatos === formato &&
    item.Compra === compra &&
    estrategiasSelecionadas.some(e => item.Estrategias.includes(e))
  );

  if (matches.length > 0) {
    // Usar o valor mais alto entre as correspondências encontradas
    let valor: number | null = null;
    
    matches.forEach(match => {
      let currentValor: number | null = null;
    if (bv) {
      if (regiao === 'Estados e Brasil') {
          currentValor = match['Com BV até 10% - Estados e Brasil'] ?? null;
      } else if (regiao === 'Grandes Metropoles') {
          currentValor = match['Com BV até 10% - Grandes Metrópoles'] ?? null;
      } else if (regiao === 'Cidades pequenas') {
          currentValor = match['Com BV até 10% - Cidades Pequenas'] ?? null;
      }
    } else {
      if (regiao === 'Estados e Brasil') {
          currentValor = match['CPM Estados e Brasil'] ?? null;
      } else if (regiao === 'Grandes Metropoles') {
          currentValor = match['CPM Grandes Metropoles'] ?? null;
      } else if (regiao === 'Cidades pequenas') {
          currentValor = match['CPM Cidade Pequena'] ?? null;
      }
    }
      
      if (currentValor !== null && (valor === null || currentValor > valor)) {
        valor = currentValor;
      }
    });

    console.log('Valor CPM/CPV retornado:', valor);
    return valor;
  }

  return null;
};

export const getObjetivos = async (): Promise<string[]> => {
  return OBJETIVOS_PERMITIDOS;
};

export const getPlataformas = async (objetivo: string): Promise<string[]> => {
  return Array.from(new Set(DEMO_DATA
    .filter(row => row.Objetivo === objetivo)
    .map(row => row.Plataforma)
  )).sort();
};

export const getFormatos = async (
  objetivo: string,
  plataforma: string
): Promise<string[]> => {
  return Array.from(new Set(DEMO_DATA
    .filter(row => 
      row.Objetivo === objetivo && 
      row.Plataforma === plataforma
    )
    .map(row => row.Formatos)
  )).sort();
};

export const getEstrategias = async (
  objetivo: string,
  plataforma: string,
  formatos: string[]
): Promise<string[]> => {
  // Normalizar os formatos para comparação
  const formatosNormalizados = formatos.map(f => f.toLowerCase());
  
  // Caso especial para YouTube no objetivo Brandformance
  if (objetivo === 'Brandformance' && formatosNormalizados.includes('youtube')) {
    return [
      'Non-Skippable e Bumper',
      'Skippable - Vídeo com mais',
      'Non-Skippable, In Stream, Discovery e Bumper'
    ];
  }
  
  return Array.from(new Set(DEMO_DATA
    .filter(row => 
      row.Objetivo === objetivo && 
      row.Plataforma === plataforma && 
      formatosNormalizados.includes(row.Formatos.toLowerCase())
    )
    .map(row => {
      // Normalizar as estratégias do YouTube
      if (row.Formatos.toLowerCase() === 'youtube') {
        const estrategias = row.Estrategias.split(',').map(e => e.trim());
        // Remover duplicatas e normalizar nomes
        return estrategias.filter((estrategia, index) => {
          const estrategiaLower = estrategia.toLowerCase();
          return !estrategias.slice(0, index).some(e => e.toLowerCase() === estrategiaLower);
        });
      }
      return row.Estrategias.split(',').map(e => e.trim());
    })
    .flat()
  )).sort();
};

export const getCompras = async (
  objetivo: string,
  plataforma: string,
  formatos: string[],
  estrategia: string
): Promise<string[]> => {
  // Normalizar a estratégia para comparação
  const estrategiasSelecionadas = estrategia
    .split(',')
    .map(e => e.trim())
    .filter(e => e.length > 0);

  // Normalizar os formatos para comparação
  const formatosNormalizados = formatos.map(f => f.toLowerCase());

  // Casos especiais por formato
  if (formatosNormalizados.includes('native')) {
    return ['CPM'];
  }

  if (formatosNormalizados.includes('display iab')) {
    return ['CPM'];
  }

  if (formatosNormalizados.includes('youtube')) {
    if (estrategiasSelecionadas.some(e => e.toLowerCase() === 'shorts')) {
      return ['CPM'];
    }
    // Para outras estratégias do YouTube, retorna as compras disponíveis baseado nos dados
    return Array.from(new Set(DEMO_DATA
      .filter(row => 
        row.Objetivo === objetivo && 
        row.Plataforma === plataforma && 
        row.Formatos.toLowerCase() === 'youtube' &&
        row.Estrategias.split(',').some(e => 
          estrategiasSelecionadas.some(estrategia => 
            estrategia.toLowerCase() === e.trim().toLowerCase()
          )
        )
      )
      .map(row => row.Compra)
    )).sort();
  }

  if (formatosNormalizados.includes('vídeo open')) {
    if (plataforma === 'GAMA') {
      return ['CPV'];
    }
    // Para DV360, retorna as compras disponíveis baseado nos dados
    return Array.from(new Set(DEMO_DATA
      .filter(row => 
        row.Objetivo === objetivo && 
        row.Plataforma === plataforma && 
        formatosNormalizados.includes(row.Formatos.toLowerCase()) &&
        row.Estrategias.split(',').some(e => 
          estrategiasSelecionadas.some(estrategia => 
            estrategia.toLowerCase() === e.trim().toLowerCase()
          )
        )
      )
      .map(row => row.Compra)
    )).sort();
  }

  // Para outros casos, retorna as compras disponíveis baseado nos dados
  return Array.from(new Set(DEMO_DATA
    .filter(row => 
      row.Objetivo === objetivo && 
      row.Plataforma === plataforma && 
      formatosNormalizados.includes(row.Formatos.toLowerCase()) &&
      row.Estrategias.split(',').some(e => 
        estrategiasSelecionadas.some(estrategia => 
          estrategia.toLowerCase() === e.trim().toLowerCase()
        )
      )
    )
    .map(row => row.Compra)
  )).sort();
};

interface AdvertisingOptions {
  objetivos: {
    [key: string]: {
      plataformas: {
        [key: string]: {
          devices: {
            [key: string]: {
              formatos: {
                [key: string]: {
                  estrategias: string[];
                  targets: {
                    [key: string]: {
                      idades: string[];
                    };
                  };
                };
              };
            };
          };
        };
      };
    };
  };
}

export const advertisingOptions: AdvertisingOptions = {
  objetivos: {
    Awareness: {
      plataformas: {
        DV360: {
          devices: {
            Mobile: {
              formatos: {
                "Display IAB": {
                  estrategias: ["Platform Data", "Wishlist Open", "Custom affinity", "Contextual (Categories)", "Demographics", "Lookalike"],
                  targets: {
                    "Homem": {
                      idades: ["18-24", "25-34", "35-44", "45-54", "55-65+"]
                    },
                    "Mulher": {
                      idades: ["18-24", "25-34", "35-44", "45-54", "55-65+"]
                    },
                    "Desconhecido": {
                      idades: ["18-24", "25-34", "35-44", "45-54", "55-65+"]
                    }
                  }
                },
                "Native": {
                  estrategias: ["Platform Data", "Wishlist Open", "Custom affinity", "Contextual (Categories)", "Demographics", "Lookalike"],
                  targets: {
                    "Homem": {
                      idades: ["18-24", "25-34", "35-44", "45-54", "55-65+"]
                    },
                    "Mulher": {
                      idades: ["18-24", "25-34", "35-44", "45-54", "55-65+"]
                    },
                    "Desconhecido": {
                      idades: ["18-24", "25-34", "35-44", "45-54", "55-65+"]
                    }
                  }
                },
                "Youtube": {
                  estrategias: ["Non Skippable", "In Stream Skippable e Bumper", "Shorts"],
                  targets: {
                    "Homem": {
                      idades: ["18-24", "25-34", "35-44", "45-54", "55-65+"]
                    },
                    "Mulher": {
                      idades: ["18-24", "25-34", "35-44", "45-54", "55-65+"]
                    },
                    "Desconhecido": {
                      idades: ["18-24", "25-34", "35-44", "45-54", "55-65+"]
                    }
                  }
                },
                "Vídeo Open": {
                  estrategias: ["Platform Data", "Wishlist Open", "Custom affinity", "Contextual (Categories)", "Demographics", "Lookalike"],
                  targets: {
                    "Homem": {
                      idades: ["18-24", "25-34", "35-44", "45-54", "55-65+"]
                    },
                    "Mulher": {
                      idades: ["18-24", "25-34", "35-44", "45-54", "55-65+"]
                    },
                    "Desconhecido": {
                      idades: ["18-24", "25-34", "35-44", "45-54", "55-65+"]
                    }
                  }
                }
              }
            },
            Desktop: {
              formatos: {
                "Display IAB": {
                  estrategias: ["Platform Data", "Wishlist Open", "Custom affinity", "Contextual (Categories)", "Demographics", "Lookalike"],
                  targets: {
                    "Homem": {
                      idades: ["18-24", "25-34", "35-44", "45-54", "55-65+"]
                    },
                    "Mulher": {
                      idades: ["18-24", "25-34", "35-44", "45-54", "55-65+"]
                    },
                    "Desconhecido": {
                      idades: ["18-24", "25-34", "35-44", "45-54", "55-65+"]
                    }
                  }
                },
                "Native": {
                  estrategias: ["Platform Data", "Wishlist Open", "Custom affinity", "Contextual (Categories)", "Demographics", "Lookalike"],
                  targets: {
                    "Homem": {
                      idades: ["18-24", "25-34", "35-44", "45-54", "55-65+"]
                    },
                    "Mulher": {
                      idades: ["18-24", "25-34", "35-44", "45-54", "55-65+"]
                    },
                    "Desconhecido": {
                      idades: ["18-24", "25-34", "35-44", "45-54", "55-65+"]
                    }
                  }
                },
                "Youtube": {
                  estrategias: ["Non Skippable", "In Stream Skippable e Bumper", "Shorts"],
                  targets: {
                    "Homem": {
                      idades: ["18-24", "25-34", "35-44", "45-54", "55-65+"]
                    },
                    "Mulher": {
                      idades: ["18-24", "25-34", "35-44", "45-54", "55-65+"]
                    },
                    "Desconhecido": {
                      idades: ["18-24", "25-34", "35-44", "45-54", "55-65+"]
                    }
                  }
                },
                "Vídeo Open": {
                  estrategias: ["Platform Data", "Wishlist Open", "Custom affinity", "Contextual (Categories)", "Demographics", "Lookalike"],
                  targets: {
                    "Homem": {
                      idades: ["18-24", "25-34", "35-44", "45-54", "55-65+"]
                    },
                    "Mulher": {
                      idades: ["18-24", "25-34", "35-44", "45-54", "55-65+"]
                    },
                    "Desconhecido": {
                      idades: ["18-24", "25-34", "35-44", "45-54", "55-65+"]
                    }
                  }
                }
              }
            }
          }
        },
        GAMA: {
          devices: {
            Mobile: {
              formatos: {
                "Display IAB": {
                  estrategias: ["Remarketing", "Open", "Wishlist", "Lookalike", "Demographics", "3rdParty"],
                  targets: {
                    "Homem": {
                      idades: ["18-24", "25-34", "35-44", "45-54", "55-65+"]
                    },
                    "Mulher": {
                      idades: ["18-24", "25-34", "35-44", "45-54", "55-65+"]
                    },
                    "Desconhecido": {
                      idades: ["18-24", "25-34", "35-44", "45-54", "55-65+"]
                    }
                  }
                },
                "Vídeo Open": {
                  estrategias: ["Remarketing", "Open", "Wishlist", "Lookalike", "Demographics", "3rdParty"],
                  targets: {
                    "Homem": {
                      idades: ["18-24", "25-34", "35-44", "45-54", "55-65+"]
                    },
                    "Mulher": {
                      idades: ["18-24", "25-34", "35-44", "45-54", "55-65+"]
                    },
                    "Desconhecido": {
                      idades: ["18-24", "25-34", "35-44", "45-54", "55-65+"]
                    }
                  }
                }
              }
            },
            Desktop: {
              formatos: {
                "Display IAB": {
                  estrategias: ["Remarketing", "Open", "Wishlist", "Lookalike", "Demographics", "3rdParty"],
                  targets: {
                    "Homem": {
                      idades: ["18-24", "25-34", "35-44", "45-54", "55-65+"]
                    },
                    "Mulher": {
                      idades: ["18-24", "25-34", "35-44", "45-54", "55-65+"]
                    },
                    "Desconhecido": {
                      idades: ["18-24", "25-34", "35-44", "45-54", "55-65+"]
                    }
                  }
                },
                "Vídeo Open": {
                  estrategias: ["Remarketing", "Open", "Wishlist", "Lookalike", "Demographics", "3rdParty"],
                  targets: {
                    "Homem": {
                      idades: ["18-24", "25-34", "35-44", "45-54", "55-65+"]
                    },
                    "Mulher": {
                      idades: ["18-24", "25-34", "35-44", "45-54", "55-65+"]
                    },
                    "Desconhecido": {
                      idades: ["18-24", "25-34", "35-44", "45-54", "55-65+"]
                    }
                  }
                }
              }
            }
          }
        }
      }
    },
    Brandformance: {
      plataformas: {
        DV360: {
          devices: {
            Mobile: {
              formatos: {
                "Display IAB": {
                  estrategias: ["Platform Data+Wishlist", "Keywords+Wishlist", "Wishlist+Audience", "Custom affinity+Wishlist", "Contextual (Categories)+Audience", "3rdParty Data", "Open App (In App)", "Demographics+Wishlist", "Remarketing", "Lookalike+Wishlist"],
                  targets: {
                    "Homem": {
                      idades: ["18-24", "25-34", "35-44", "45-54", "55-65+"]
                    },
                    "Mulher": {
                      idades: ["18-24", "25-34", "35-44", "45-54", "55-65+"]
                    },
                    "Desconhecido": {
                      idades: ["18-24", "25-34", "35-44", "45-54", "55-65+"]
                    }
                  }
                },
                "Native": {
                  estrategias: ["Platform Data+Wishlist", "Keywords+Wishlist", "Wishlist+Audience", "Custom affinity+Wishlist", "Contextual (Categories)+Audience", "3rdParty Data", "Open App (In App)", "Demographics+Wishlist", "Remarketing", "Lookalike+Wishlist"],
                  targets: {
                    "Homem": {
                      idades: ["18-24", "25-34", "35-44", "45-54", "55-65+"]
                    },
                    "Mulher": {
                      idades: ["18-24", "25-34", "35-44", "45-54", "55-65+"]
                    },
                    "Desconhecido": {
                      idades: ["18-24", "25-34", "35-44", "45-54", "55-65+"]
                    }
                  }
                },
                "Youtube": {
                  estrategias: ["Non-Skippable e Bumper", "Skippable - Vídeo com mais", "Non-Skippable, In Stream, Discovery e Bumper"],
                  targets: {
                    "Homem": {
                      idades: ["18-24", "25-34", "35-44", "45-54", "55-65+"]
                    },
                    "Mulher": {
                      idades: ["18-24", "25-34", "35-44", "45-54", "55-65+"]
                    },
                    "Desconhecido": {
                      idades: ["18-24", "25-34", "35-44", "45-54", "55-65+"]
                    }
                  }
                },
                "Vídeo Open": {
                  estrategias: ["Platform Data", "Keywords", "Wishlist+Audience", "Custom affinity", "Contextual (Categories)", "3rdParty Data", "Open App (In App)", "Demographics", "Remarketing", "Lookalike+Wishlist"],
                  targets: {
                    "Homem": {
                      idades: ["18-24", "25-34", "35-44", "45-54", "55-65+"]
                    },
                    "Mulher": {
                      idades: ["18-24", "25-34", "35-44", "45-54", "55-65+"]
                    },
                    "Desconhecido": {
                      idades: ["18-24", "25-34", "35-44", "45-54", "55-65+"]
                    }
                  }
                }
              }
            },
            Desktop: {
              formatos: {
                "Display IAB": {
                  estrategias: ["Platform Data+Wishlist", "Keywords+Wishlist", "Wishlist+Audience", "Custom affinity+Wishlist", "Contextual (Categories)+Audience", "3rdParty Data", "Open App (In App)", "Demographics+Wishlist", "Remarketing", "Lookalike+Wishlist"],
                  targets: {
                    "Homem": {
                      idades: ["18-24", "25-34", "35-44", "45-54", "55-65+"]
                    },
                    "Mulher": {
                      idades: ["18-24", "25-34", "35-44", "45-54", "55-65+"]
                    },
                    "Desconhecido": {
                      idades: ["18-24", "25-34", "35-44", "45-54", "55-65+"]
                    }
                  }
                },
                "Native": {
                  estrategias: ["Platform Data+Wishlist", "Keywords+Wishlist", "Wishlist+Audience", "Custom affinity+Wishlist", "Contextual (Categories)+Audience", "3rdParty Data", "Open App (In App)", "Demographics+Wishlist", "Remarketing", "Lookalike+Wishlist"],
                  targets: {
                    "Homem": {
                      idades: ["18-24", "25-34", "35-44", "45-54", "55-65+"]
                    },
                    "Mulher": {
                      idades: ["18-24", "25-34", "35-44", "45-54", "55-65+"]
                    },
                    "Desconhecido": {
                      idades: ["18-24", "25-34", "35-44", "45-54", "55-65+"]
                    }
                  }
                },
                "Youtube": {
                  estrategias: ["Non-Skippable e Bumper", "Skippable - Vídeo com mais", "Non-Skippable, In Stream, Discovery e Bumper"],
                  targets: {
                    "Homem": {
                      idades: ["18-24", "25-34", "35-44", "45-54", "55-65+"]
                    },
                    "Mulher": {
                      idades: ["18-24", "25-34", "35-44", "45-54", "55-65+"]
                    },
                    "Desconhecido": {
                      idades: ["18-24", "25-34", "35-44", "45-54", "55-65+"]
                    }
                  }
                },
                "Vídeo Open": {
                  estrategias: ["Platform Data", "Keywords", "Wishlist+Audience", "Custom affinity", "Contextual (Categories)", "3rdParty Data", "Open App (In App)", "Demographics", "Remarketing", "Lookalike+Wishlist"],
                  targets: {
                    "Homem": {
                      idades: ["18-24", "25-34", "35-44", "45-54", "55-65+"]
                    },
                    "Mulher": {
                      idades: ["18-24", "25-34", "35-44", "45-54", "55-65+"]
                    },
                    "Desconhecido": {
                      idades: ["18-24", "25-34", "35-44", "45-54", "55-65+"]
                    }
                  }
                }
              }
            }
          }
        },
        GAMA: {
          devices: {
            Mobile: {
              formatos: {
                "Display IAB": {
                  estrategias: ["Remarketing", "Open", "Wishlist", "Lookalike", "Demographics", "3rdParty"],
                  targets: {
                    "Homem": {
                      idades: ["18-24", "25-34", "35-44", "45-54", "55-65+"]
                    },
                    "Mulher": {
                      idades: ["18-24", "25-34", "35-44", "45-54", "55-65+"]
                    },
                    "Desconhecido": {
                      idades: ["18-24", "25-34", "35-44", "45-54", "55-65+"]
                    }
                  }
                },
                "Vídeo Open": {
                  estrategias: ["Remarketing", "Open", "Wishlist", "Lookalike", "Demographics", "3rdParty"],
                  targets: {
                    "Homem": {
                      idades: ["18-24", "25-34", "35-44", "45-54", "55-65+"]
                    },
                    "Mulher": {
                      idades: ["18-24", "25-34", "35-44", "45-54", "55-65+"]
                    },
                    "Desconhecido": {
                      idades: ["18-24", "25-34", "35-44", "45-54", "55-65+"]
                    }
                  }
                }
              }
            },
            Desktop: {
              formatos: {
                "Display IAB": {
                  estrategias: ["Remarketing", "Open", "Wishlist", "Lookalike", "Demographics", "3rdParty"],
                  targets: {
                    "Homem": {
                      idades: ["18-24", "25-34", "35-44", "45-54", "55-65+"]
                    },
                    "Mulher": {
                      idades: ["18-24", "25-34", "35-44", "45-54", "55-65+"]
                    },
                    "Desconhecido": {
                      idades: ["18-24", "25-34", "35-44", "45-54", "55-65+"]
                    }
                  }
                },
                "Vídeo Open": {
                  estrategias: ["Remarketing", "Open", "Wishlist", "Lookalike", "Demographics", "3rdParty"],
                  targets: {
                    "Homem": {
                      idades: ["18-24", "25-34", "35-44", "45-54", "55-65+"]
                    },
                    "Mulher": {
                      idades: ["18-24", "25-34", "35-44", "45-54", "55-65+"]
                    },
                    "Desconhecido": {
                      idades: ["18-24", "25-34", "35-44", "45-54", "55-65+"]
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

export const getNextOptions = (selections: Record<string, string>): string[] => {
  const { objetivo, plataforma, device, formato, estrategia, target } = selections;

  if (!objetivo) {
    return Object.keys(advertisingOptions.objetivos);
  }

  if (!plataforma) {
    return Object.keys(advertisingOptions.objetivos[objetivo].plataformas);
  }

  if (!device) {
    return Object.keys(advertisingOptions.objetivos[objetivo].plataformas[plataforma].devices);
  }

  if (!formato) {
    return Object.keys(advertisingOptions.objetivos[objetivo].plataformas[plataforma].devices[device].formatos);
  }

  if (!estrategia) {
    return advertisingOptions.objetivos[objetivo].plataformas[plataforma].devices[device].formatos[formato].estrategias;
  }

  if (!target) {
    return Object.keys(advertisingOptions.objetivos[objetivo].plataformas[plataforma].devices[device].formatos[formato].targets);
  }

  return advertisingOptions.objetivos[objetivo].plataformas[plataforma].devices[device].formatos[formato].targets[target].idades;
}; 
